/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
export const fetchTenantFullDetails = async (tenantId, token) => {
  // SuperAdmin mode: always allow -1
  const finalTenantId = tenantId ?? -1;

  const baseUrl =
    process.env.NODE_ENV === "development"
      ? "/api"
      : process.env.REACT_APP_API_BASE_URL ||
      "https://madar-api.madar.iq/api";

  const res = await fetch(`${baseUrl}/GetAllTenantFullDetails?tenantId=-1`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    },
  });

  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }

  const contentType = res.headers.get("content-type");
  let data;

  if (contentType && contentType.includes("application/json")) {
    data = await res.json();
  } else {
    const text = await res.text();
    try {
      data = JSON.parse(text);
    } catch {
      throw new Error("Invalid response format");
    }
  }

  if (!Array.isArray(data)) {
    throw new Error("Invalid data format");
  }

  return data;
};
export async function getTenantDetails(tenantId) {
  const baseUrl = "https://madar-api.madar.iq/api";

  const res = await fetch(`${baseUrl}/GetAllTenantFullDetails?tenantId=${tenantId}`);

  if (!res.ok) throw new Error("Failed to load tenant details");

  const data = await res.json();
  return data[0]; // يرجع أول عنصر
}

